import { render, staticRenderFns } from "./MainSliderSlide.vue?vue&type=template&id=723627b0&scoped=true"
import script from "./MainSliderSlide.vue?vue&type=script&lang=js"
export * from "./MainSliderSlide.vue?vue&type=script&lang=js"
import style0 from "./MainSliderSlide.vue?vue&type=style&index=0&id=723627b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723627b0",
  null
  
)

export default component.exports